<!-- 
 * @author song
 * @since 2022-04-21
 * @publisher  宏脉信息技术（广州）股份有限公司
 -->
<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="手机号码" prop="cusPhone">
          <el-input
            v-model="form.cusPhone"
            type="text"
            maxlength="11"
            size="small"
            show-word-limit
            style="width:280px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input
            v-model="form.cusName"
            type="text"
            maxlength="10"
            size="small"
            show-word-limit
            style="width:280px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注信息">
          <el-input
            v-model="form.remark"
            type="textarea"
            maxlength="50"
            size="small"
            show-word-limit
            style="width:280px;"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="type == 'add'" @click="handleDefine(true)" size="mini"
          >保存并继续创建</el-button
        >
        <el-button
          v-if="type == 'add'"
          type="primary"
          @click="handleDefine(false)"
          size="mini"
          >完成</el-button
        >
        <el-button
          v-if="type == 'edit'"
          @click="dialogVisible = false"
          size="mini"
          >取消</el-button
        >
        <el-button
          v-if="type == 'edit'"
          type="primary"
          @click="handleDefine(false)"
          size="mini"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  postNewTask,
  postUpdateTask,
} from "../../../../api/addFriends/addFriends.js";
export default {
  name: "Fount",
  data() {
    return {
      dialogVisible: false,
      title: "",
      form: {
        cusPhone: "",
        cusName: "",
        remark: "",
      },
      type: "add",
      rules: {
        cusPhone: [
          { required: true, message: "请输入电话", trigger: "blur" },
          { validator: this.handlePhone, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    async handleDefine(isBool) {
      // 校验表单XXX
      let isRef = true;
      this.$refs.form.validate((valid) => {
        isRef = valid;
      });
      if (!isRef) {
        return this.$message.warning("手机号码校验不通过");
      }
      let data = {};
      // 去除输入的空格
      this.form.remark=this.form.remark.replace(/\s*/g,"")
      this.form.cusName=this.form.cusName.replace(/\s*/g,"")
      if (this.form.id.length <= 0) {
        console.log("XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX");
        data = await postNewTask(
          this.form,
          localStorage.getItem("Authorization")
        );
      } else {
        data = await postUpdateTask(
          this.form,
          localStorage.getItem("Authorization")
        );
      }
      if (data.error.code == 200) {
        this.$message.success("创建成功");
      }
      this.dialogVisible = isBool;
      this.form.cusPhone = "";
      this.form.cusName = "";
      this.form.remark = "";
      this.$emit("upload");
      console.log("XXXXXXXXXX", this.form, data);
    },
    handlePhone(rule, value, callback) {
      console.log("自定义校验规则XXX", rule, value, callback);
      let reg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (!reg.test(value)) {
        callback(new Error("手机号码输入不正确"));
      } else {
        callback();
      }
    },
    handleClose(done) {
      this.dialogVisible = false;
      // this.$confirm("确认关闭？")
      //   .then((_) => {
      //     done();
      //   })
      //   .catch((_) => {});
    },
  },
};
</script>
